import { Component, OnInit, ViewChild, Inject, Directive, HostListener } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormsModule } from '@angular/forms';
import { Login } from '@models/login-dto';
import { ServiceLogin } from '@services/ServiceLogin';
import { ModalsComponent } from '../../notifications/modals.component';
import { MustMatch } from '../../../helpers/must-match.validator';
import { Router } from '@angular/router';
import { LOCAL_STORAGE, WebStorageService } from 'angular-webstorage-service';
import { global } from '../../../_nav';
import { ModalDirective } from 'ngx-bootstrap/modal';
declare var jQuery: any;
@Component({
  selector: 'app-dashboard',
  templateUrl: 'loginAdminReset.component.html',
  styleUrls: ['loginAdminReset.component.css']
})


export class LoginAdminResetComponent implements OnInit {
  @ViewChild(ModalsComponent) public modales: ModalsComponent;
  @ViewChild('okModal') public okModal: ModalDirective;
  public mensaje: string = "";
  okmodal() {
    this.okModal.show();
  }
  public modelo: Login;
  loginFormulario: FormGroup;
  router: Router;
  public loading = false;
  public _menu: string;
  public submitted = false;
  public data: any = []
  public empresaLogin: any = [];
  public empresaMod: any = [];
  public empresa: boolean = true;
  public elem;
  constructor(@Inject(LOCAL_STORAGE) private storage: WebStorageService,
    _router: Router, private formBuilder: FormBuilder, private servicio: ServiceLogin, private globalVar: global) {
    this.router = _router;
    this.nuevo();
  }
   ngOnInit() {
    this.loginFormulario = this.formBuilder.group({
     usuario: ['', Validators.required]
    });
  }


  CrearPassword(longitud): any {
    var caracteres = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ1234567890";
    let randomstring = '';
    for (let i = 0; i < longitud; i++) {
      const rnum = Math.floor(Math.random() * caracteres.length);
      randomstring += caracteres.substring(rnum, rnum + 1);
    }
    return randomstring;
  }

  okActualizacion(): any {
    this.router.navigate(['/loginAdmin']);
  }

  UsuarioReset(): any {
    if (this.loginFormulario.invalid) {
      this.modales.dangermodal("Por favor completar los campos necesarios.");
      return;
    }
    this.loading = true;
    this.modelo.Clave = this.CrearPassword(10);
    this.servicio.getLoginResetAdmin(this.modelo).subscribe((results) => {
      try {
        if (results.codError.toString() === "0") {
          this.loading = false;
          this.mensaje = "Se envio un correo con la nueva contraseña por favor revisar";
          this.okmodal();
        }
        
    
      } catch (e) {
        this.loading = false;
        this.ngOnInit();
      }
    }, err => {
      this.loading = false;
    });
  }
  cargar() {
    if (this.empresaMod.length == 0) {
      this.modales.dangermodal("Por favor debe seleccionar una empresa.");
      return;
    } else {
      var emp = [];
      emp = this.storage.get("EMPRESA");
      var empArray = [];
      for (var i = 0; i < emp.length; i++) {
        if (emp[i].emp_codigo == this.empresaMod) {
          empArray.push(emp[i]);
          this.storage.set("EMPRESA", empArray);
          this.router.navigate(['/seguridad/principal']);
        }
      };


    }

  }
  cancelar() {
    this.empresa = true;
    this.modelo.Ruc = "";
    this.modelo.Usuario = "";
    this.modelo.Clave = "";
    this.empresaMod = [];
    this.empresaLogin = [];
    this.router.navigate(['/loginAdmin']);
  }

  nuevo() {
    this.modelo = new Login();
  }
  get f() { return this.loginFormulario.controls; }


  onReset() {
    this.loginFormulario.reset();
  }

}
